import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import Button from 'Mui/Button';
import Typography from '@material-ui/core/Typography';
import useLogoutRedirect from 'client/hooks/logout/useLogoutRedirect';

import { system900 } from 'Mui/styles/color';
import { below } from 'utils/breakpoint';

function KKboxUpgradeMemberLevel({ logout }) {
    const redirectEnterpriseLogout = useLogoutRedirect();

    function handleUpgradeBtnClick() {
        window.open('https://ssl.kkbox.com/tw/billing/index.php', '_blank');
    }

    return (
        <div css={[maskInfoStyle, coverStyle]}>
            <div css={contentStyle}>
                <Typography variant="h6">{i18n.t('label.sign_error')}</Typography>
                <Typography variant="h6" css={css(`text-align: center;`)}>
                    {i18n.t('label.member_upgrade_notification')}
                </Typography>
            </div>
            <div css={btnContainerStyle}>
                <Button variant="contained" css={successBtnStyle} onClick={handleUpgradeBtnClick}>
                    {i18n.t('btn.upgrade')}
                </Button>
                <Button onClick={() => logout(redirectEnterpriseLogout)} css={cancelBtnStyle}>
                    {i18n.t('label.logout')}
                </Button>
            </div>
        </div>
    );
}

KKboxUpgradeMemberLevel.propTypes = {
    logout: PropTypes.func
};

export default KKboxUpgradeMemberLevel;

const contentStyle = css`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const btnContainerStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    margin-bottom: 16px;
`;

const successBtnStyle = css`
    background: ${system900.color};
    color: #fff;
    &:hover {
        background: rgba(85, 85, 85, 0.8);
    }
    width: 500px;
    ${below('xsm')} {
        width: 100%;
    }
`;

const cancelBtnStyle = css`
    margin-top: 8px;
    width: 500px;
    ${below('xsm')} {
        width: 100%;
    }
`;

const coverStyle = css`
    padding: 16px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
`;

const maskInfoStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(4px);
`;
